const RugGuaranteeToBluStatus = Object.freeze({
    PENDING: 0,
    INCLUDE: 10,
    IGNORE: 20
})

module.exports = RugGuaranteeToBluStatus
